import React, { useState, useEffect } from 'react';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { useAuth } from '../../contexts/AuthContext';

const RoleSwitcher = () => {
  const { currentUser } = useAuth();
  const [profile, setProfile] = useState(null);
  const [currentRole, setCurrentRole] = useState('learner');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (currentUser) {
      fetchProfile();
    }
  }, [currentUser]);

  const fetchProfile = async () => {
    try {
      const docRef = doc(db, 'users', currentUser.uid);
      const docSnap = await getDoc(docRef);
      
      if (docSnap.exists()) {
        const profileData = docSnap.data();
        setProfile(profileData);
        setCurrentRole(profileData.activeRole || 'learner');
      }
    } catch (error) {
      console.error('Error fetching profile:', error);
    } finally {
      setLoading(false);
    }
  };

  const switchRole = async (newRole) => {
    if (!currentUser || !profile) return;

    try {
      setLoading(true);
      const docRef = doc(db, 'users', currentUser.uid);
      await updateDoc(docRef, {
        activeRole: newRole
      });
      
      setCurrentRole(newRole);
      // Reload the page to update the navigation
      window.location.reload();
    } catch (error) {
      console.error('Error switching role:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading || !profile) {
    return null;
  }

  // Only show role switcher if user can be both roles
  if (profile.userType !== 'both') {
    return null;
  }

  return (
    <div className="role-switcher">
      <label className="role-switcher-label">Active Role:</label>
      <div className="role-toggle">
        <button 
          className={`role-btn ${currentRole === 'learner' ? 'active' : ''}`}
          onClick={() => switchRole('learner')}
          disabled={loading}
        >
          <span className="role-icon">📚</span>
          Practitioner
        </button>
        <button 
          className={`role-btn ${currentRole === 'provider' ? 'active' : ''}`}
          onClick={() => switchRole('provider')}
          disabled={loading}
        >
          <span className="role-icon">👨‍🏫</span>
          Provider
        </button>
      </div>
    </div>
  );
};

export default RoleSwitcher;